// material-ui
import {} from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'

import { Button, Grid, Stack } from '@mui/material'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import ContentCreatorForm from 'components/ContentCreatorForm'
import { getUserClaims } from 'features/application/application-slice'
import { get_selected_contentCreator } from 'features/contentCreator/contentCreator-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let contentCreator = useSelector(get_selected_contentCreator)
  const [valid, setValid] = React.useState(null)
  const [dirty, setDirty] = React.useState(null)
  const [formChanges, setFormChanges] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.load_my_content_house_content_crerator({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id])

  function submit(context) {
    return () =>
      autoThunks.update_my_contenthouse_contentcreator_profile({
        userId: (() => {
          function get_userId(): any {
            return claims.user
          }
          return get_userId()
        })(),
        contentCreator: (() => {
          function _get_current(): any {
            return { ...contentCreator, ...formChanges }
          }
          return _get_current()
        })(),
      })
  }
  function createContentCreatorForm(submit: any): any {
    return (
      <>
        <ContentCreatorForm
          page={undefined}
          context={{
            profileImage: {
              image: true,
              title: TitleService('Profile Image'),
              componentTitle: TitleService('Profile Image'),
              storageLocation: `images/${claims?.contentCreator}/ContentCreator_ProfileImages`,
            },
          }}
          onUpdate={(form, valid, dirty) => {
            setValid(valid)
            setDirty(dirty)
            setFormChanges(form)
          }}
          form={{ ...contentCreator, ...formChanges }}
        />
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end">
            <AnimateButton>
              <Button
                variant="contained"
                disabled={!valid}
                onClick={async () => {
                  await dispatch(submit()())
                  setFormChanges({})
                  setValid(false)
                  setDirty(false)
                }}
              >
                {TitleService('Verify & Submit')}
              </Button>
            </AnimateButton>
          </Stack>
        </Grid>
      </>
    )
  }

  let output_createContentCreatorForm = createContentCreatorForm(submit)

  function get_me(form: any): any {
    return (
      <MainCard title={TitleService('Me')}>
        <Busy />
        <Grid container spacing={gridSpacing}>
          {form}
        </Grid>
      </MainCard>
    )
  }

  let output_get_me = get_me(output_createContentCreatorForm)

  return output_get_me
}
